<template>
  <div class="loader-wrapper" v-bind:class="{ 'is-active': is_loading }">
    <!-- <progress class="progress is-small is-primary" max="100"></progress> -->
    <div class="elmnt">
      <div class="columns">
        <div class="column">
          <div class="loader is-loading"></div>
          <div class="has-text-centered">{{ $t("loading") }}</div>
        </div>
      </div>
      <div class="columns">
        <div class="column"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoaderComponent",
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    set_loading(value) {
      this.is_loading = value;
    },
  },
  watch: {},
};
</script>

<style scoped>
.loader-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #000000c9;
  /* background: #ffffff44; */
  opacity: 0;
  z-index: -1;
  transition: opacity 0s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;

  .loader {
    height: 80px;
    width: 80px;
    border-bottom: 2px solid transparent;
    border-left: 2px solid hsl(160, 76%, 46%);
    border-radius: var(--bulma-radius-rounded);
    border-right: 2px solid transparent;
    border-top: 2px solid hsl(160, 76%, 46%);
    animation: spinAround 1s alternate infinite;
  }

  &.is-active {
    opacity: 1;
    z-index: 102;
  }
}

/* .element {
  &.is-loading {
    position: relative;
    pointer-events: none;
    opacity: 0.2;
    &:after {
      @include loader;
      position: absolute;
      top: calc(50% - 2.5em);
      left: calc(50% - 2.5em);
      width: 5em;
      height: 5em;
      border-width: 0.25em;
    }
  }
} */
</style>
